import React from 'react';
import styled from 'styled-components';
import { translate, numberFormat } from '~/utils';

const ChartLabel = styled.text`
  font-size: 12px;
  text-anchor: middle;
`;

const AxisLabel = styled(ChartLabel)`
  font-weight: bold;
`;

const Axis = ({
  transform = 'translate(0, 0)',
  scale,
  ticks = [],
  margin,
  isRelView,
}) => {
  const renderTick = (tick) => {
    const translation = translate(scale(tick), 12);
    const decimals = isRelView ? 1 : 0;
    const prefix = tick === 200 ? '≥ ' : '';

    return (
      <g key={translation} transform={translation}>
        <ChartLabel>
          {prefix}
          {numberFormat(tick, decimals)}
        </ChartLabel>
      </g>
    );
  };

  return <g transform={transform}>{ticks.map(renderTick)}</g>;
};

export default Axis;
